"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardPerformanceBandDistribution = void 0;
/**
 * It holds the standard performance band distribution information, it provides information
 * about how what assignees are in a specific band
 *
 * @property {string}                           standard            - standard
 * @property {string}                           totalItems          - total items evaluated
 * @property {PerformanceBandDistribution[]}    distribution        - the assignee distribution per band
 */
var StandardPerformanceBandDistribution = /** @class */ (function () {
    function StandardPerformanceBandDistribution(distribution) {
        if (distribution === void 0) { distribution = {}; }
        Object.assign(this, distribution);
    }
    StandardPerformanceBandDistribution.prototype.addPerformanceBandDistribution = function (distribution) {
        if (!this.distribution) {
            this.distribution = [];
        }
        this.distribution.push(distribution);
    };
    return StandardPerformanceBandDistribution;
}());
exports.StandardPerformanceBandDistribution = StandardPerformanceBandDistribution;
